import React, { Component } from 'react';

import Street1 from '../../../../shared-components/AddressComponent/Street1/Street1';
import Street2 from '../Street2/Street2';
import City from '../../../../shared-components/AddressComponent/City/City';
import PostalCode from '../../../../shared-components/AddressComponent/PostalCode/PostalCode';
import State from '../State/State';
import Col from '../../../../shared-components/VXGrid/Col';
import Row from '../../../../shared-components/VXGrid/Row';
import { GB_COUNTRY } from '../../../config/GBConstants';

const LOCALE_PREFIX = 'GB/components/Address/Address';

export class AddressGroup extends Component {
    render() {
        return (
            <div className="addressGroup">
                <Row className="addressGroup-streetOne" gutterSize={10}>
                    <Col xs={12}>
                        <Street1 localePrefix={LOCALE_PREFIX} />
                    </Col>
                </Row>
                <Row className="addressGroup-streetTwo" gutterSize={10}>
                    <Col xs={12}>
                        <Street2 />
                    </Col>
                </Row>
                <Row className="addressGroup-streetCity" gutterSize={10}>
                    <Col xs={12}>
                        <City localePrefix={LOCALE_PREFIX} />
                    </Col>
                </Row>
                <Row className="addressGroup-CountyPostcode" gutterSize={10}>
                    <Col xs={7} className="addressGroup-State">
                        <State />
                    </Col>
                    <Col xs={5} className="addressGroup-PostalCode">
                        <PostalCode localePrefix={LOCALE_PREFIX} country={GB_COUNTRY} />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default AddressGroup;
